import { useParams } from 'react-router-dom'
import EditExerciseForm from './EditExerciseForm'
import { useGetExercisesQuery } from './exercisesApiSlice'
import { useGetBodypartsQuery } from "./bodypartsApiSlice"
import { useGetExercisetypesQuery } from "./exercisetypesApiSlice"

import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditExercise = () => {
    useTitle('DPE: Edit Exercise')

    const { id } = useParams()

    const { exercise } = useGetExercisesQuery("exercisesList", {
        selectFromResult: ({ data }) => ({
            exercise: data?.entities[id]
        }),
    })

    const { bodyparts } = useGetBodypartsQuery("bodypartsList", {
        selectFromResult: ({ data }) => ({
            bodyparts: data?.ids.map(id => data?.entities[id])
        }),
    })

    const { exercisetypes } = useGetExercisetypesQuery("exercisetypesList", {
        selectFromResult: ({ data }) => ({
            exercisetypes: data?.ids.map(id => data?.entities[id])
        }),
    })




    if (!exercise) return <PulseLoader color={"#5f788a"} />

    const content = <EditExerciseForm exercise={exercise}  bodyparts={bodyparts} exercisetypes={exercisetypes} />

    return content
}
export default EditExercise